/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Optional_LabelInputs */



/**
* | output |
* | --- |
* | "optional" |
*
* @param {Team_Sync_Optional_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_optional_label = /** @type {((inputs?: Team_Sync_Optional_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Optional_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("facultatif")
	if (locale === "de") return /** @type {LocalizedString} */ ("optional")
	if (locale === "it") return /** @type {LocalizedString} */ ("opzionale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("необязательный")
	if (locale === "es") return /** @type {LocalizedString} */ ("opcional")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选修的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वैकल्पिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("opcional")
	return /** @type {LocalizedString} */ ("optional")
});